import React, { useState } from 'react';
import Slider from "react-slick";
import { RiStarFill } from "react-icons/ri";
import { HiArrowRight, HiArrowLeft } from "react-icons/hi";
import Title from '../layouts/Title';
import { testimonialOne, testimonialTwo, quote } from "../../assets";

// Component for the next arrow button in the slider
function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-14 h-12 bg-[#0c1821] hover:bg-black duration-300 rounded-md text-2xl text-gray-400 flex justify-center items-center absolute top-0 right-0 shadow-shadowOne cursor-pointer z-10"
      onClick={onClick}
    >
      <HiArrowRight />
    </div>
  );
}

// Component for the previous arrow button in the slider
function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-14 h-12 bg-[#0c1821] hover:bg-black duration-300 rounded-md text-2xl text-gray-400 flex justify-center items-center absolute top-0 right-20 shadow-shadowOne cursor-pointer z-10"
      onClick={onClick}
    >
      <HiArrowLeft />
    </div>
  );
}

const Testimonial = () => {
  const [dotActive, setDotActive] = useState(0);

  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (prev, next) => {
      setDotActive(next);
    },
    appendDots: (dots) => (
      <div
        style={{
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <ul
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={
          i === dotActive
            ? {
                width: "12px",
                height: "12px",
                background: "#ff014f",
                borderRadius: "50%",
                cursor: "pointer",
              }
            : {
                width: "12px",
                height: "12px",
                background: "gray",
                borderRadius: "50%",
                cursor: "pointer",
              }
        }
      ></div>
    ),
  };

  return (
    <section id="testimonial" className="w-full py-20 border-b-[1px] border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title title="FEEDBACK FROM COLLEAGUES & COLLABORATORS" des="What People Have to Say" />
      </div>
      <div className="max-w-6xl mx-auto px-4">
        {/* Slider One */}
        <Slider {...settings}>
          <div className="w-full">
            <div className="w-full h-auto flex flex-col lg:flex-row justify-between gap-6 lg:gap-8">
              <div className="w-full lg:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-6 lg:p-8 rounded-lg shadow-shadowOne flex flex-col gap-6 justify-center">
                <img
                  className="h-64 md:h-48 lg:h-72 rounded-lg object-cover w-full"
                  src={testimonialOne}
                  alt="Testimonial from team member"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs uppercase text-designColor tracking-wide mb-2">
                    IntalksAI - Backend Team
                  </p>
                  <h3 className="text-xl lg:text-2xl font-bold">Team Lead</h3>
                  <p className="text-sm lg:text-base tracking-wide text-gray-500">
                    Engineering Manager
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-[60%] h-full flex flex-col justify-between">
                <img className="w-16 lg:w-24" src={quote} alt="quote" />
                <div className="w-full py-8 lg:py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lg:p-8 flex flex-col justify-center gap-4 lg:gap-8">
                  <div className="flex flex-col justify-between py-4 lg:py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h4 className="text-lg lg:text-xl font-medium tracking-wide">
                        FastAPI Backend & Security Testing
                      </h4>
                      <p className="text-sm lg:text-base text-gray-400 mt-2">
                        Aug 2025 - Present
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1 mt-3 lg:mt-0">
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                    </div>
                  </div>
                  <p className="text-sm lg:text-base text-gray-400 font-medium tracking-wide leading-6">
                    Kushal built solid FastAPI services with proper auth and validation. My favorite part was how he caught missing auth checks on internal routes before they hit production. That's the kind of attention to detail you need on a backend team.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Slider Two */}
          <div className="w-full">
            <div className="w-full h-auto flex flex-col lg:flex-row justify-between gap-6 lg:gap-8">
              <div className="w-full lg:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-6 lg:p-8 rounded-lg shadow-shadowOne flex flex-col gap-6 justify-center">
                <img
                  className="h-64 md:h-48 lg:h-72 rounded-lg object-cover w-full"
                  src={testimonialTwo}
                  alt="Testimonial from workshop attendee"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs uppercase text-designColor tracking-wide mb-2">
                    IILM University - GDG Workshop
                  </p>
                  <h3 className="text-xl lg:text-2xl font-bold">Student Developer</h3>
                  <p className="text-sm lg:text-base tracking-wide text-gray-500">
                    Third Year CSE
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-[60%] h-full flex flex-col justify-between">
                <img className="w-16 lg:w-24" src={quote} alt="quote" />
                <div className="w-full py-8 lg:py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lg:p-8 flex flex-col justify-center gap-4 lg:gap-8">
                  <div className="flex flex-col justify-between py-4 lg:py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h4 className="text-lg lg:text-xl font-medium tracking-wide">
                        OWASP Top 10 Workshop
                      </h4>
                      <p className="text-sm lg:text-base text-gray-400 mt-2">
                        Workshop at IILM - 2024
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1 mt-3 lg:mt-0">
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                    </div>
                  </div>
                  <p className="text-sm lg:text-base text-gray-400 font-medium tracking-wide leading-6">
                    Kushal's security workshop made everything click for me. He explained vulnerabilities like SQLi and XSS in a way that actually made sense. He spent time answering everyone's questions. That's rare in tech talks.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Slider Three */}
          <div className="w-full">
            <div className="w-full h-auto flex flex-col lg:flex-row justify-between gap-6 lg:gap-8">
              <div className="w-full lg:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-6 lg:p-8 rounded-lg shadow-shadowOne flex flex-col gap-6 justify-center">
                <img
                  className="h-64 md:h-48 lg:h-72 rounded-lg object-cover w-full"
                  src={testimonialOne}
                  alt="Testimonial from freelance client"
                />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs uppercase text-designColor tracking-wide mb-2">
                    DigitalDose - WordPress Client
                  </p>
                  <h3 className="text-xl lg:text-2xl font-bold">Business Owner</h3>
                  <p className="text-sm lg:text-base tracking-wide text-gray-500">
                    E-commerce Manager
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-[60%] h-full flex flex-col justify-between">
                <img className="w-16 lg:w-24" src={quote} alt="quote" />
                <div className="w-full py-8 lg:py-10 bg-gradient-to-r from-[#1e2024] to-[#23272b] rounded-lg shadow-shadowOne p-4 lg:p-8 flex flex-col justify-center gap-4 lg:gap-8">
                  <div className="flex flex-col justify-between py-4 lg:py-6 border-b-2 border-b-gray-900">
                    <div>
                      <h4 className="text-lg lg:text-xl font-medium tracking-wide">
                        Website Security & Optimization
                      </h4>
                      <p className="text-sm lg:text-base text-gray-400 mt-2">
                        Jun - Aug 2024
                      </p>
                    </div>
                    <div className="text-yellow-500 flex gap-1 mt-3 lg:mt-0">
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                      <RiStarFill />
                    </div>
                  </div>
                  <p className="text-sm lg:text-base text-gray-400 font-medium tracking-wide leading-6">
                    Our WordPress site was slow and getting hit by bots. Kushal fixed security issues, optimized the database, and our page loads are 25% faster now. Very responsive and easy to work with.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
  };

export default Testimonial;
